import React from "react";
import { Navigate } from "react-router-dom";
import { AppSuspense } from "../AppSuspense";
import CheckoutFlow from "../Checkout/components/LegacyCheckoutFlow";
import CheckoutSummary from "../Checkout/components/CheckoutSummary";
import Loading from "../Loading";
import { StoreNavAction } from "../StoreComponents/StoreSinglePageOutlet";
import { AppRoutesWithChildrenProps } from "./routeBuilder";

const ContentFlow = React.lazy(
  () => import("../pages/AppPages/Pages/Content/flow")
);
const ReviewFlow = React.lazy(
  () => import("../pages/AppPages/Pages/Review/flow")
);
const SurveyFlow = React.lazy(
  () => import("../pages/AppPages/Pages/Survey/flow")
);

const JoinBrandStoreBrandClubSuccess = React.lazy(
  () => import("../pages/AppPages/BrandStore/JoinBrandstoreBrandclubSuccess")
);
const MembershipProgram = React.lazy(
  () => import("../pages/AppPages/MembershipProgram")
);

export const singlePageCustomCloseRoutes: AppRoutesWithChildrenProps[] = [
  {
    path: "joinclubsuccess/:brandId",
    index: true,
    element: <JoinBrandStoreBrandClubSuccess />,
  },
];
export const membershipProgramRoutes: AppRoutesWithChildrenProps[] = [
  {
    path: "membership/",
    index: true,
    element: <MembershipProgram />,
    handle: {
      pageNavConfig: {
        // hasViewBagButton: true,
      },
    },
  },
];

export const dtcCheckoutRoutes: AppRoutesWithChildrenProps[] = [
  {
    path: "checkout/",
    element: <CheckoutFlow />,
    handle: {
      pageNavConfig: {
        close: StoreNavAction.ToBag,
      },
    },
    pageType: "Checkout",
  },
  {
    // for backward compatibility
    path: "entercheckout/",
    element: <Navigate to="/checkout" replace />,
  },
];

export const dtcSinglePageRoutes: AppRoutesWithChildrenProps[] = [
  {
    path: "content/:campaignId",
    element: (
      <AppSuspense fallback={<Loading dot></Loading>}>
        <ContentFlow />
      </AppSuspense>
    ),
    handle: {
      pageNavConfig: {
        close: StoreNavAction.Back,
      },
    },
    pageType: "Content",
  },
  {
    path: "survey/:campaignId",
    element: (
      <AppSuspense fallback={<Loading dot></Loading>}>
        <SurveyFlow />
      </AppSuspense>
    ),
    handle: {
      pageNavConfig: {
        close: StoreNavAction.Back,
      },
    },
    pageType: "Survey",
  },
  {
    path: "review/:stacklineSku",
    element: (
      <AppSuspense fallback={<Loading dot></Loading>}>
        <ReviewFlow />
      </AppSuspense>
    ),
    handle: {
      pageNavConfig: {
        close: StoreNavAction.Back,
      },
    },
    pageType: "Review",
  },
];

export const singlePageRoutes: AppRoutesWithChildrenProps[] = [
  {
    path: "checkoutSummary/",
    element: <CheckoutSummary />,
    handle: {
      pageNavConfig: {
        close: StoreNavAction.ToBag,
      },
    },
  },
  {
    path: "checkout/",
    element: <CheckoutFlow />,
    handle: {
      pageNavConfig: {
        close: StoreNavAction.ToBag,
      },
    },
    pageType: "Checkout",
  },
  {
    // for backward compatibility
    path: "entercheckout/",
    element: <Navigate to="/checkout" replace />,
  },
  {
    path: "content/:campaignId",
    element: (
      <AppSuspense fallback={<Loading dot></Loading>}>
        <ContentFlow />
      </AppSuspense>
    ),
    handle: {
      pageNavConfig: {
        close: StoreNavAction.Back,
      },
    },
    pageType: "Content",
  },
  {
    path: "survey/:campaignId",
    element: (
      <AppSuspense fallback={<Loading dot></Loading>}>
        <SurveyFlow />
      </AppSuspense>
    ),
    handle: {
      pageNavConfig: {
        close: StoreNavAction.Back,
      },
    },
    pageType: "Survey",
  },
  {
    path: "review/:stacklineSku",
    element: (
      <AppSuspense fallback={<Loading dot></Loading>}>
        <ReviewFlow />
      </AppSuspense>
    ),
    handle: {
      pageNavConfig: {
        close: StoreNavAction.Back,
      },
    },
    pageType: "Review",
  },
];
